import { Helmet } from "react-helmet";
import PolicyLayout from "../sections/policy/policyLayout";
import privacyPolicy from '../data/privacyPolicy.json';

const PrivacyPolicyPage = () => {
    <Helmet>
        <title>Privacy Policy</title>
        <meta name="description" content="Your child’s safety and privacy matter to us. Read the Learn with Cuddles privacy policy to understand how Edliena protects personal information and ensures safe, fun learning for kids." />
        <meta name="keywords" content="Learn with Cuddles privacy policy, Edliena privacy, kids online safety, data protection, safe learning for kids, children privacy, parental trust, secure educational games" />
        <link rel="canonical" href="https://cuddles.edliena.com/privacy-policy" />
    </Helmet>

    return (
        <>
            <PolicyLayout data={privacyPolicy}/>
        </>
    );
}

export default PrivacyPolicyPage;